module.exports = __webpack_public_path__ + "img/desk mat.164e287b.svg";